// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"2805c914","121":"3120d417","370":"8fd09e83","720":"fdf68553"}[chunkId] + ".chunk.js";
};